import axios from 'axios'
import API from '@/common/api'
import store from '..'

export default {
  namespaced: true,
  state: {
    cid: null,
    received: 0,
    talkOpen: false,
    gotMessage: {},
    localTranslate: [],
    updateSetting: false
  },
  mutations: {
    setCid (state, cid) {
      state.cid = cid
    },
    received (state, data) {
      state.received = data
    },
    talkOpen (state, isOpen) {
      state.talkOpen = isOpen
    },
    gotMessage (state, message) {
      state.gotMessage = message
    },
    updateSetting (state, isUpdate) {
      state.updateSetting = isUpdate
    }
  },
  actions: {
    async chatToken ({ dispatch, state }, data) { // create
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const ota = siteInfo && siteInfo.k
      try {
        const res = await axios.post(`${API.BASE_URL}/service/staytalk`, {
          cmd: 'sc-chat-token',
          siteid: siteid,
          ...ota && {
            ota: ota
          },
          ...data.cid && {
            cid: data.cid
          },
          ...data.userName && {
            userName: data.userName
          },
          ...data.userPhone && {
            userPhone: data.userPhone
          },
          ...data.userEmail && {
            userEmail: data.userEmail
          }
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async postMessage ({ dispatch, state }, data) {
      const siteInfo = API.SITE_INFO
      if (!window.navigator.onLine) {
        return false
      }
      try {
        const res = await axios.post(`${API.BASE_URL}/service/staytalk`, {
          cmd: 'sc-post-message',
          siteid: siteInfo.site,
          cid: data.cid,
          from: 'user',
          msgId: data.msgId,
          type: data.type || 'text',
          ...data.content && {
            text: data.content
          },
          ...data.data && { // type === video (image or video)
            fileName: data.fileName,
            data: data.data
          },
          userName: data.userName || `user_${data.cid}`
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async getMessage ({ dispatch, state }, data) {
      const siteInfo = API.SITE_INFO
      const page = data.page || 50
      try {
        const res = await axios.post(`${API.BASE_URL}/service/staytalk`, {
          cmd: 'sc-log',
          func: 'get-message-list',
          siteid: siteInfo.site,
          id: siteInfo.site,
          ...data,
          page: page
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex.response.data)
        return false
      }
    },
    async getChannel ({ dispatch, state }, data) {
      const siteInfo = API.SITE_INFO
      try {
        const res = await axios.post(`${API.BASE_URL}/service/staytalk`, {
          cmd: 'sc-log',
          func: 'get-channel',
          siteid: siteInfo.site,
          cid: data.cid
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex.response.data)
        return false
      }
    },
    async updateChannel ({ dispatch, state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/staytalk`, {
          cmd: 'sc-channel',
          func: 'update',
          ...data // userName, userPhone, userEmail
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex.response.data)
        return false
      }
    },
    async readByUser ({ dispatch, state }, data) {
      const siteInfo = API.SITE_INFO
      try {
        const res = await axios.post(`${API.BASE_URL}/service/staytalk`, {
          cmd: 'sc-read-by-user',
          siteid: siteInfo.site,
          cid: data.cid,
          msgIds: data.msgIds
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async getSetting ({ dispatch, state }, data) {
      const file = 'talk/talk.json'
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`).then(res => {
        return res.data.message
      }).catch((ex) => {
        return false
      })
    },
    async getCenterSetting ({ dispatch, state }) {
      const siteInfo = API.SITE_INFO
      try {
        const res = await axios.post(`${API.BASE_URL}/service/staytalk`, {
          cmd: 'sc-info',
          siteid: siteInfo.site,
          func: 'get-service-info'
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    async getTranslate ({ dispatch, state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/service/staytalk`, {
          cmd: 'sc-translate',
          msgId: data.msgId,
          text: data.text,
          to: data.to
        })
        return res.data
      } catch (ex) {
        return ex.response.data
      }
    },
    async resizeVideo ({ state, dispatch }, data) {
      if (data) {
        try {
          const res = await axios.post(`${API.BASE_URL}/service/staytalk`, {
            cmd: 'sc-video-resize',
            siteid: API.SITE_INFO.site,
            from: 'user',
            type: 'video',
            cid: data.cid,
            msgId: data.msgId,
            fileName: data.fileName,
            ...data.userName && {
              userName: data.userName
            },
            ...data.userEmail && {
              userEmail: data.userEmail
            },
            ...data.userPhone && {
              userPhone: data.userPhone
            }
          })
          return res
        } catch (ex) {
          console.log(ex.response.data)
          return false
        }
      }
    },
    async uploadVideo ({ state }, data) {
      const AWS = require('aws-sdk')
      const s3 = new AWS.S3({
        region: 'ap-northeast-1',
        accessKeyId: 'AKIA5MBTG4BFCQ6DF6VS',
        secretAccessKey: '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'
      })
      const param = {
        Bucket: 'staytalk-video-resize-source',
        ACL: 'public-read',
        Key: data.key,
        Body: data.body
      }
      try {
        const res = await s3.upload(param).promise()
        return res
      } catch (ex) {
        console.log(ex)
        return ex.response.data
      }
    }
  },
  getters: {
    gotMessage: state => state.gotMessage,
    updateSetting: state => state.updateSetting
  }
}